import { loadStripe } from "@stripe/stripe-js";

const stripePublicApiKey =
  process.env.NODE_ENV === "production"
    ? "pk_live_EplThadFizKJpvxyP6Xqfjw900aktPJZOS"
    : "pk_test_51Grs9OBZSLzokmiVTGWgb04GC9mH8RZcLbCYOgc5clV24LaHHbyu5DxQiuWc38mFBfS0MltqmbStiOaJRe7Rwx310048RB3uso";
const stripePromise = loadStripe(stripePublicApiKey).catch(() => undefined);

export default stripePromise;
